import type { ReactNode } from "react";
import { ResponsiveModal } from "@/v2/ui/composed/responsive-modal";
import { DialogDescription } from "@/v2/ui/primitives/dialog";

export interface ConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: ReactNode;
  confirmText?: string;
  cancelText?: string;
  variant?: "default" | "destructive";
  loading?: boolean;
  onCloseAutoFocus?: (event: Event) => void;
  className?: string;
}

export function ConfirmationModal({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmText,
  cancelText,
  variant = "default",
  loading = false,
  onCloseAutoFocus,
  className,
}: ConfirmationModalProps) {
  return (
    <ResponsiveModal
      open={open}
      onOpenChange={(isOpen) => !isOpen && onClose()}
      title={title}
      onCancel={onClose}
      onConfirm={onConfirm}
      confirmLabel={confirmText}
      cancelLabel={cancelText}
      confirmVariant={variant}
      loading={loading}
      onCloseAutoFocus={onCloseAutoFocus}
      className={className}
    >
      <DialogDescription>{description}</DialogDescription>
    </ResponsiveModal>
  );
}
